import { PlusOutlined } from '@ant-design/icons';
import { Form, message, Modal, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import { api } from '@/utils';

const ImgFileTypeData = ['', 'image/jpeg', 'image/jpeg', 'image/gif', 'image/png'];
const VideoFileTypeData = ['', 'video/mp4'];
const UploadMultiple = (props) => {
  const {
    setTemporaryImgUrl, // 是从form取，还是自己获取上传
    name = 'file',
    requiredType = false,
    label,
    messageText = false,
    uploadNum = 5,
    fileData = [], // 回显数量
    fileType,
    form,
    extra,
  } = props;
  const [fileList, setFileList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewTitle, setPreviewTitle] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  /* 回显数量控制 */
  useEffect(() => {
    if (fileData) {
      setFileList(fileData);
    }
  }, [fileData]);

  /* beforeUpload中把文件对象存下来 */
  useEffect(() => {
    if (setTemporaryImgUrl) setTemporaryImgUrl(fileList);
  }, [fileList]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  function handleCancel() {
    setPreviewVisible(false);
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const uploadButton = (
    <div style={{ color: '#44BB55' }}>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{label || '上传图片'}</div>
    </div>
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    const url = file.url || file.preview;
    setPreviewImage(url);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    setPreviewVisible(true);
  };

  /* 文件校验 */
  const handleChange = ({ fileList }) => {
    console.log('handleChange', fileList);
    const newFileList = [];
    for (let k = 0; k < fileList.length; k++) {
      const par = fileList[k];
      const isLt2M = fileList[k].size / 1024 / 1024 < (fileType === 'image' ? 2 : 50);
      const imgIndex = ImgFileTypeData.findIndex((n) => n === par.type);
      const videoIndex = VideoFileTypeData.findIndex((n) => n === par.type);
      if (fileList[k].error) {
        par.error = '服务器开了小差~';
        message.error('上传失败(检查图片大小、格式)');
      }
      /* 图片 */
      if (fileType === 'image') {
        if (videoIndex > -1 || !isLt2M || fileList[k].error) {
          // Modal.error({
          //   title: `只能上传JPG 、JPEG 、GIF、 PNG格式的图片${!isLt2M &&
          //     `或${!isLt2M ? '文件大小不超过2M' : ''}`}`
          // })
        } else {
          newFileList.push(par);
        }
      }
      /* 视频 */
      if (fileType === 'video') {
        if (imgIndex > -1 || !isLt2M || fileList[k].error) {
          // Modal.error({
          //   title: `只能上传mp4格式的视频${(!isLt2M && '或文件大小不超过2M') ||
          //     ''}`
          // })
        } else {
          newFileList.push(par);
        }
      }
      /* 编辑 */
      if (fileList[k].isEdit) {
        newFileList.push(par);
      }
    }
    form.setFieldsValue({
      [name]: newFileList,
    });
    setFileList(newFileList);
  };

  const beforeUpload = (file) => {
    console.log('beforeUpload', file);
    const isLt2M = file.size / 1024 / 1024 < (fileType === 'image' ? 5 : 50);
    const imgIndex = ImgFileTypeData.findIndex((n) => n === file.type);
    const videoIndex = VideoFileTypeData.findIndex((n) => n === file.type);
    let imgBool = false;
    let videoBool = false;
    /* 图片 */
    if (fileType === 'image') {
      if (
        (file.type !== 'image/png' &&
          file.type !== 'image/jpg' &&
          file.type !== 'image/jpeg' &&
          file.type !== 'image/gif') ||
        !isLt2M
      ) {
        imgBool = false;
        Modal.error({
          title: `只能上传JPG 、JPEG 、GIF、 PNG格式的图片${!isLt2M && `或${!isLt2M ? '文件大小不超过5M' : ''}`}`,
        });
      } else {
        imgBool = true;
      }
      return imgBool || Upload.LIST_IGNORE;
    }
    /* 视频 */
    if (fileType === 'video') {
      if (imgIndex > -1 || !isLt2M) {
        videoBool = false;
        Modal.error({
          title: `只能上传mp4格式的视频${(!isLt2M && '或文件大小不超过2M') || ''}`,
        });
      } else {
        videoBool = true;
      }
      return videoBool || Upload.LIST_IGNORE;
    }
  };

  const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
  return (
    <div>
      <Form.Item
        label={label || '上传图片'}
        valuePropName="fileList"
        name={name}
        extra={extra}
        getValueFromEvent={normFile}
        rules={[{ required: requiredType, message: messageText }]}
      >
        <Upload
          name="file"
          listType="picture-card"
          action={fileType === 'image' ? api.smallUploadFile : api.videoUploadFile}
          className="avatar-uploader"
          withCredentials
          onPreview={handlePreview}
          headers={{
            Authorization: `Bearer ${userInfo.token}`,
          }}
          onChange={handleChange}
          onRemove={(file) => {
            let i;
            if (file.originFileObj) {
              i = fileList.indexOf(file);
            } else {
              i = fileList.findIndex((n) => n.uid === file.uid);
            }
            const newFileList = fileList.slice();
            newFileList.splice(i, 1);
            setFileList(newFileList);
          }}
          beforeUpload={beforeUpload}
          fileList={fileList}
        >
          {fileList.length >= uploadNum ? null : uploadButton}
        </Upload>
      </Form.Item>
      <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
        {fileType === 'image' && <img alt="example" style={{ width: '100%' }} src={previewImage} />}
        {fileType === 'video' && <video src={previewImage?.split('?')[0]} controls="controls" className="video" />}
      </Modal>
    </div>
  );
};

export default UploadMultiple;
